exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".teacher_area .cnt_block[data-v-4b9e5657] {\n  padding: 32px 38px 48px;\n}\n.btn_area[data-v-4b9e5657] {\n  margin-top: 18px;\n  text-align: right;\n}\n@media (max-width: 768px) {\n.btn_area[data-v-4b9e5657] {\n    text-align: center;\n    margin-top: 21px;\n}\n}", ""]);

// exports
